 
import { useState } from 'react';

export default function DataTable({ data, columns }) {
    const [sortKey, setSortKey] = useState(null);
    const [sortDir, setSortDir] = useState('asc');
    const [search,  setSearch]  = useState('');

    if (!data || !data.length) return <p className="empty">No data for selected filters.</p>;

    const filtered = data.filter(row =>
        columns.some(col =>
            String(row[col.key] ?? '').toLowerCase().includes(search.toLowerCase())
        )
    );

    const sorted = [...filtered].sort((a, b) => {
        if (!sortKey) return 0;
        const va = a[sortKey], vb = b[sortKey];
        return (va < vb ? -1 : va > vb ? 1 : 0) * (sortDir === 'asc' ? 1 : -1);
    });

    function handleSort(key) {
        if (sortKey === key) setSortDir(d => d === 'asc' ? 'desc' : 'asc');
        else { setSortKey(key); setSortDir('asc'); }
    }

    return (
        <div className="table-wrapper">
            <input
                className="table-search"
                placeholder="Search anything..."
                value={search}
                onChange={e => setSearch(e.target.value)}
            />
            <table>
                <thead>
                    <tr>
                        {columns.map(col => (
                            <th key={col.key} onClick={() => handleSort(col.key)}>
                                {col.label}
                                {sortKey === col.key ? (sortDir === 'asc' ? ' ↑' : ' ↓') : ''}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {sorted.map((row, i) => (
                        <tr key={i}>
                            {columns.map(col => (
                                <td key={col.key}>
                                    {row[col.key] ?? '—'}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
            <p className="row-count">{sorted.length} of {data.length} rows</p>
        </div>
    );
}
